import React from 'react'
import { connect } from 'react-redux'
import Autocomplete from 'react-autocomplete'
import { fetchEndpointIfNeeded } from '../../actions/fetch'
import getParams from './getParams'

class ReferenceAutocomplete extends React.Component {
    constructor(props) {
        super(props)

        this.handleLocalChange = this.handleLocalChange.bind(this)
        this.handleSelect = this.handleSelect.bind(this)
        this.handleClear = this.handleClear.bind(this)
        this.changeCallback = this.changeCallback.bind(this)
        this.mainInput = HTMLInputElement

        let epList = []


        let foundEndpoint = this.props.endpoints.find(elem =>
            elem.name === this.props.endpointName
        )
        if (foundEndpoint) {
            if (foundEndpoint.list.length === 0) {
                this.props.dispatch(fetchEndpointIfNeeded(foundEndpoint.id))
                    .then(respObj => {
                        if (respObj.response.ok) {
                            respObj.json.then(json => {
                                this.setState({
                                    epList: json
                                })
                            })
                        }
                    })
            }

            if (foundEndpoint.list.length > 0) {
                epList = foundEndpoint.list.map(fep => {
                    return {
                        badge: this.props.endpointName,
                        id: fep.id,
                        name: fep.name
                    }
                })
            }
        }

        let autocompleteInputValue = ""
        /* BAD CODE, NEEDS REFACTOR
        if(isNaN(Number(this.props.value))){
            autocompleteInputValue = this.props.value
        } else {
            
        }*/
        // Initial State
        this.state = {
            actualValue: this.props.value,
            autocompleteInputValue: autocompleteInputValue,
            epList: epList
        }
    }

    componentDidMount() {

        const params = getParams(this.props.location && this.props.location.search ? this.props.location.search : "")
        const endPointId = this.props.id
        const getEndpointName = this.props.endpointName
        let getPreviousValue = null;
        let getPreviousName = null;


        // to get previous task id 
        for (var list of this.props.endpoints) {

            if (list.id == endPointId) {
                getPreviousValue = list.filter.task_id.value1

            }

        }

        // to get the previous task name
        if (getPreviousValue) {

            for (var endPointlist of this.props.endpoints) {
                if (endPointlist.name == getEndpointName) {
                    for (var taskList of endPointlist.list) {
                        if (taskList.id == getPreviousValue) {
                            getPreviousName = taskList.name
                        }
                    }
                }
            }
        }


        this.setState((state) => {
            return Object.assign({}, state,
                {
                    autocompleteInputValue: params.task || getPreviousName || "",
                    actualValue: params.task_id || getPreviousValue || "",
                })
        }, this.changeCallback)

    }

    static getDerivedStateFromProps(props) {
        let foundEndpoint = props.endpoints.find(elem =>
            elem.name === props.endpointName
        )

        if (foundEndpoint && foundEndpoint.initialized && foundEndpoint.list.length > 0) {
            let epList = foundEndpoint.list.map(fep => {
                return {
                    badge: props.endpointName,
                    id: fep.id,
                    name: fep.name
                }
            })

            return {
                epList
            }
        }

        return null
    }

    changeCallback() {
        // since we are setting the main input value programatically, we need to trigger onChange
        // event manually so Formik can save the changed value
        let actualValue = this.state.actualValue
        let nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set
        nativeInputValueSetter.call(this.mainInput, actualValue)

        var ev2 = new Event('input', { bubbles: true })
        this.mainInput.dispatchEvent(ev2)
    }

    handleLocalChange(event) {
        let autoCompleteInputVal = event.target.value
        this.setState({
            actualValue: autoCompleteInputVal === "" ? "" : this.state.actualValue,
            autocompleteInputValue: autoCompleteInputVal
        }, () => {
            if (autoCompleteInputVal === "") {
                this.changeCallback()
            }
        })
    }

    handleSelect(value, item) {
        let selectedItem = item
        let selectedValue = value
        this.setState({
            actualValue: item.id === "autocompleteItemForStr" ? selectedValue : selectedItem.id,
            autocompleteInputValue: selectedValue
        }, this.changeCallback)
    }

    handleClear() {
        this.setState({
            actualValue: "",
            autocompleteInputValue: ""
        }, this.changeCallback)
    }

    render() {
        let {
            value,
            id,
            name,
            placeholder
        } = this.props


        if (value === null) {
            value = ""
        }

        return (
            <div className="reference-autocomplete" style={{ marginRight: "5px" }}>
                <input hidden type="text" id={id} name={name}
                    defaultValue={this.props.value}
                    ref={node => this.mainInput = node}
                    onChange={this.props.onChange} />
                <Autocomplete
                    type="text"
                    value={this.state.autocompleteInputValue}
                    onChange={this.handleLocalChange}
                    getItemValue={(item) => item.name}
                    onSelect={this.handleSelect}
                    items={this.state.epList || []}
                    shouldItemRender={(item, value) => {
                        let itemName = item.name.toLowerCase()
                        let currentVal = value.toLowerCase()
                        return value !== "" && itemName.includes(currentVal)
                    }}
                    renderItem={(item, isHighlighted) =>
                        <div key={item.id} className="autocomplete-item p-2" style={{ background: isHighlighted ? 'lightgray' : 'white', fontSize: "12px" }}>
                            <div>{item.name}</div>
                        </div>
                    }
                    renderMenu={(items) => {
                        return (
                            <div className="autocomplete-menu" children={items} />
                        )
                    }}
                    inputProps={{
                        className: "form-control ",
                        placeholder: placeholder,
                        onBlur: (e) => {
                            if (e.target.value === "") {
                                this.setState({
                                    actualValue: ""
                                }, this.changeCallback)
                            }
                            if (e.target.value !== "" && this.state.actualValue === "") {
                                // If user typed, but did not select from the dropdown, clear it
                                // because the only way to set the filter is to select and not just type
                                this.setState({
                                    actualValue: "",
                                    autocompleteInputValue: ""
                                })
                            }
                        }
                    }}
                />
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        endpoints: state.endpoints,
        onChange: ownProps.onChange,
        endpointName: ownProps.endpointName,
        value: ownProps.value,
        id: ownProps.id,
        name: ownProps.name
    }
}

export default connect(mapStateToProps, null, null, { withRef: true })(ReferenceAutocomplete)


// WEBPACK FOOTER //
// ./src/components/utilities/ReferenceAutocomplete.js